module.exports = __webpack_public_path__ + "img/16.32a08bf9.jpg";